import { render, staticRenderFns } from "./OperationMaintenanceRecord.vue?vue&type=template&id=2fa80360&scoped=true"
import script from "./OperationMaintenanceRecord.vue?vue&type=script&lang=js"
export * from "./OperationMaintenanceRecord.vue?vue&type=script&lang=js"
import style0 from "./OperationMaintenanceRecord.vue?vue&type=style&index=0&id=2fa80360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa80360",
  null
  
)

export default component.exports